import { LEGAL_COOKIES_HEADING } from './0-heading.md';
import { LEGAL_WHAT_ARE_COOKIES } from './1-what-are-cookies.md';
import { LEGAL_CRACKING_THE_COOKIE_CODE } from './3-cracking-the-cookie-code.md';


/**------------------------------------------------------
 * Imprint Template
 */
export const LEGAL_COOKIES_USAGE_INTRO_EN: string = `
	${LEGAL_COOKIES_HEADING}
	${LEGAL_WHAT_ARE_COOKIES}
	---
`;

export const LEGAL_COOKIES_USAGE_CODE_EN: string = `
	---
	${LEGAL_CRACKING_THE_COOKIE_CODE}
`;
